import type {ExtractContentBlockType} from '@/components/content-blocks/ContentBlocks';
import {
	TESTIMONIAL_FRAGMENT,
	testimonialFragmentToTestimonialDetails,
} from '@/components/testimonial/query';
import type {TestimonialDetails} from '@/components/testimonial/types';
import type {KeyedArray} from '@/utils/types';

export const TESTIMONIAL_LIST_SELECTION_FRAGMENT = `//groq
	...,
	testimonials[]-> {
		${TESTIMONIAL_FRAGMENT}
	}
`;

export type TestimonialListSelectionFragment =
	ExtractContentBlockType<'testimonialListSelection'>;

export const testimonialListFromTestimonialListSelectionSection = (
	section: TestimonialListSelectionFragment,
): KeyedArray<TestimonialDetails> => {
	const testimonials: KeyedArray<TestimonialDetails> = [];

	if (!section.testimonials) {
		return testimonials;
	}

	for (const testimonial of section.testimonials) {
		if (testimonial) {
			const testimonialDetails =
				testimonialFragmentToTestimonialDetails(testimonial);
			if (testimonialDetails) {
				testimonials.push({
					_key: testimonial._id,
					...testimonialDetails,
				});
			}
		}
	}

	return testimonials;
};
